import React from "react";
import { StyledCol, StyledTable, StyledTableBody, StyledTableHead, StyledTableRow } from "../../styles/styledTable";
import { StyledBlockLabel, StyledFormBlock } from "../../styles/styledTabsForm";

const ExchangeFeeHistoryContent = ({ exchangeFeeHistories, t }) => {

  if (exchangeFeeHistories.length === 0) {
    return <></>;
  }

  let feeHistories = Object.entries(exchangeFeeHistories[0]).filter(([key]) => !key.startsWith("@"));
  feeHistories = feeHistories.filter(([key]) => key.startsWith("in")).concat(feeHistories.filter(([key]) => key.startsWith("out")), feeHistories.filter(([key]) => !key.startsWith("in") && !key.startsWith("out")))

  return (
    <StyledFormBlock className="exchange-history-details__block">
      <StyledBlockLabel>
        {t("history.details.content.fees")}
      </StyledBlockLabel>
      <StyledTable size="14">
        <StyledTableHead col="2" className="exchange-history-details__head">
          <StyledCol>
            {t("history.details.content.key")}:
          </StyledCol>
          <StyledCol>
            {t("history.details.content.value")}:
          </StyledCol>
        </StyledTableHead>
        <StyledTableBody>
          {feeHistories && feeHistories.map((item, key) => (
            <StyledTableRow key={key} col="2" className="exchange-history-details__row">
              <StyledCol data-title={t("key")}>
                {item[0]}
              </StyledCol>
              <StyledCol data-title={t("value")}>
                {item[1]}
              </StyledCol>
            </StyledTableRow>
          ))}
        </StyledTableBody>
      </StyledTable>
    </StyledFormBlock>
  );
};

export default ExchangeFeeHistoryContent;
